/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DeleteAttachment$Params {

/**
 * ID stránky
 */
  id: number;

/**
 * ID verzie
 */
  versionId: number;

/**
 * ID prílohy
 */
  attachmentId: number;
}

export function deleteAttachment(http: HttpClient, rootUrl: string, params: DeleteAttachment$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
  const rb = new RequestBuilder(rootUrl, deleteAttachment.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('versionId', params.versionId, {});
    rb.path('attachmentId', params.attachmentId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
    })
  );
}

deleteAttachment.PATH = '/admin/content/{id}/version/{versionId}/attachment/{attachmentId}';
